import { dimensions } from "@/mocks/home";

export default function DimensionWall() {
  return (
    <section id="dimensions" className="w-full bg-background-100 py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl mb-8 md:mb-10">
            <span className="inline-flex items-center gap-1.5 text-accent-700 text-sm font-medium">
              <i className="ri-layout-grid-line text-base leading-none"></i>
              分析维度
            </span>
            <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              六个拆解角度，覆盖从画面到背景
            </h2>
            <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
              同一段素材会被反复拆到不同维度里，每个维度只负责回答一类问题，避免结论互相打架。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {dimensions.map((dim) => (
              <a
                key={dim.id}
                href="#feed"
                className="group rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 cursor-pointer hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${dim.icon} text-xl leading-none`}></i>
                  </span>
                  <span className="text-foreground-500 text-xs whitespace-nowrap">{dim.count}</span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-lg group-hover:text-primary-600 transition-colors">
                  {dim.name}
                </h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{dim.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-primary-600 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  查看相关条目
                  <i className="ri-arrow-right-s-line text-base leading-none"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}